import React from 'react';
import './AccountSidebar.css';

const AccountSidebar = ({ currentTab, onTabChange, userName, onNavigateHome }) => {
    const menuItems = [
        { id: 'dashboard', label: 'Tableau de bord', icon: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z' },
        { id: 'booking', label: 'Prendre RDV', icon: 'M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z M16 2v4 M8 2v4 M3 10h18' },
        { id: 'history', label: 'Mes Véhicules', icon: 'M18.5 10A1.5 1.5 0 0 1 20 11.5V16h-11V11.5A1.5 1.5 0 0 1 10.5 10z M9 16v3h10v-3 M5 16h3v3h-3z' },
        { id: 'quotes', label: 'Mes Devis', icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6' },
        { id: 'invoices', label: 'Mes Factures', icon: 'M12 2L2 7l10 5 10-5-10-5zm0 9l2.5-1.25L12 8.5l-2.5 1.25L12 11zm0 2.5l-5-2.5-5 2.5L12 22l10-8.5-5-2.5-5 2.5z' },
        { id: 'profile', label: 'Mon Profil', icon: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M12 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8z' },
    ];

    return (
        <aside className="account-sidebar">
            <div className="sidebar-user-section">
                <div className="user-avatar-large">
                    {userName ? userName.charAt(0) : 'U'}
                </div>
                <h3>{userName || 'Utilisateur'}</h3>
                <span className="user-badge">Client Privilège</span>
            </div>

            <nav className="sidebar-nav">
                {menuItems.map((item) => (
                    <button
                        key={item.id}
                        className={`sidebar-nav-link ${currentTab === item.id ? 'active' : ''}`}
                        onClick={() => onTabChange(item.id)}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d={item.icon} />
                            {item.id === 'history' && <circle cx="7" cy="17" r="2" />}
                            {item.id === 'history' && <circle cx="17" cy="17" r="2" />}
                        </svg>
                        <span>{item.label}</span>
                        {item.id === 'booking' && <span className="nav-badge">Nouveau</span>}
                    </button>
                ))}
            </nav>

            <div className="sidebar-footer">
                <p>Besoin d'aide ?</p>
                <button className="support-btn">Contacter le support</button>
            </div>
        </aside>
    );
};

export default AccountSidebar;
